// https://www.w3.org/TR/2019/NOTE-wai-aria-practices-1.1-20190207/examples/menu-button/js/Menubutton2.js

import A11yModal from './a11y-modal'

export default function A11yModalButton(node) {
  this.node = node
  this.modal = false
}

A11yModalButton.prototype.init = function () {
  this.initModal()
  this.node.addEventListener('click', this.toggleModal.bind(this))
}

A11yModalButton.prototype.initModal = function () {
  var modal = document.getElementById(this.node.getAttribute('aria-controls'))
  if (modal) {
    this.modal = new A11yModal(modal, this)

    if (
      this.node.getAttribute('aria-expanded') &&
      this.node.getAttribute('aria-expanded') == 'true'
    ) {
      this.modal.open()
    }
  }
}

A11yModalButton.prototype.toggleModal = function () {
  if (this.node.getAttribute('aria-expanded') == 'true') {
    ;[
      ...document.querySelectorAll(
        `[aria-controls='${this.node.getAttribute('aria-controls')}']`,
      ),
    ].forEach((element) => {
      element.setAttribute('aria-expanded', 'false')
    })

    this.modal.close(true)
    document.querySelector(this.node.getAttribute('data-a11y-focus')).focus()
  } else {
    ;[
      ...document.querySelectorAll(
        `[aria-controls='${this.node.getAttribute('aria-controls')}']`,
      ),
    ].forEach((element) => {
      element.setAttribute('aria-expanded', 'true')
    })

    this.modal.open()

    if (this.node.getAttribute('data-a11y-focus')) {
      document.querySelector(this.node.getAttribute('data-a11y-focus')).focus()
    }
  }
}
